import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/revenue/page', data, {
    trim: true
  })
}

export function create (data) {
  return request.post('/business/revenue/create', data)
}

export function updateStatus (data) {
  return request.post('/business/revenue/updateStatus', data)
}

export function updateById (data) {
  return request.post('/business/revenue/updateShop', data)
}

export function deleteById (id) {
  return request.get(`/business/revenue/delete/${id}`)  
}

export function deleteByIdInBatch (ids) {
  return request.get('/business/revenue/delete/batch', {
    params: {
      ids
    }
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/revenue/exportExcel', data, {
    download: true,
    trim: true
  })
}